/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { array, func, string } from 'prop-types';
import { isEmpty } from 'App/utils/helper';
import { AgilitySelectField } from 'Src/AgilityComponents';
import i18n from 'i18next';
import React, { useEffect, useState } from 'react';

const FeedInOptions = props => {
  const { options } = props;
  const [feedInList, setFeedInList] = useState([]);
  const [selectedFeedIn, setSelectedFeedIn] = useState(0);

  useEffect(() => {
    let feedInOptions = [];
    feedInOptions = options
      .filter(opt => props.nmiHasSmartMeter || !opt.is_smart_meter_only)
      .map(opt => {
        return {
          value: opt.id,
          label: opt.description,
        };
      });

    setFeedInList(feedInOptions);
    setSelectedFeedIn(feedInOptions[0].value);

    props.onSelectFeedIn(
      options.filter(opt => opt.id === feedInOptions[0].value)[0]
    );
  }, [options]);

  const handleFeedInChange = event => {
    setSelectedFeedIn(event.target.value);
    if (event.target.value > 0) {
      props.onSelectFeedIn(
        options.filter(opt => opt.id === event.target.value)[0]
      );
    }
  };

  return (
    <React.Fragment>
      {!isEmpty(feedInList) && feedInList.length > 1 && (
        <div className="mt-2 mb-2">
          <AgilitySelectField
            options={feedInList}
            variant="outlined"
            fullWidth
            className={`feedin-options mb-0 ${
              selectedFeedIn === 0 ? 'placeholder-item' : ''
            }`}
            value={selectedFeedIn}
            onChange={handleFeedInChange}
            showlabel={true}
            placeholder={i18n.t('compareplan.feedIn.placeholder')}
            MenuProps={{ classes: { paper: 'feedin-menu-item' } }}
            isError={props.errors}
            helperText={
              props.errors && i18n.t('compareplan.errorMessage.feedIn')
            }
          />
        </div>
      )}
    </React.Fragment>
  );
};
FeedInOptions.propTypes = {
  productType: string,
  options: array,
  onSelectFeedIn: func,
};
FeedInOptions.defaultProps = {
  options: [],
};
export default FeedInOptions;
